import PropTypes from 'prop-types';
import React from 'react';
import css from './BrandInfo.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var BrandInfo = function BrandInfo(_ref) {
  var description = _ref.description,
      Logo = _ref.logo;
  return /*#__PURE__*/_jsx("section", {
    className: css.root,
    children: /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx(Logo, {
        className: css.logo
      }), /*#__PURE__*/_jsx("p", {
        className: css.description,
        dangerouslySetInnerHTML: {
          __html: description
        }
      })]
    })
  });
};

BrandInfo.propTypes = {
  description: PropTypes.string.isRequired,
  logo: PropTypes.elementType.isRequired
};
export default BrandInfo;